<template>
    <div class="sellsy-ai-loader">
        <div class="sellsy-ai-loader__circle">
            <AILoader />
        </div>
    </div>
</template>
<script>
import AILoader from 'vcomponents/icons/AiLoader.vue';
export default {
    name: 'SellsyAILoader',
    components: {
        AILoader,
    },
};
</script>
<style lang="scss" scoped>
.sellsy-ai-loader {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    width: 100%;

    &__circle {
        animation: spin 1.6s linear infinite;
    }
}
</style>
